import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { Users, ShieldCheck, UserPlus, Flag, LayoutDashboard } from 'lucide-react';

const navItems = [
  { to: '/admin', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/admin/users', label: 'Users', icon: Users },
  { to: '/admin/verification', label: 'Verification', icon: ShieldCheck },
  { to: '/admin/fake-profiles', label: 'Fake Profiles', icon: UserPlus },
  { to: '/admin/reports', label: 'Reports', icon: Flag },
];

const AdminLayout = () => {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-slate-100 flex">
      <aside className="w-56 bg-white border-r border-slate-200 flex flex-col">
        <div className="p-4 border-b border-slate-200">
          <Link to="/admin" className="font-heading font-bold text-primary">Admin</Link>
        </div>
        <nav className="p-2 flex-1">
          {navItems.map(({ to, label, icon: Icon }) => (
            <Link
              key={to}
              to={to}
              className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                location.pathname === to || (to !== '/admin' && location.pathname.startsWith(to))
                  ? 'bg-primary/10 text-primary'
                  : 'text-slate-600 hover:bg-slate-100'
              }`}
            >
              <Icon className="h-4 w-4" />
              {label}
            </Link>
          ))}
        </nav>
        <div className="p-2 border-t border-slate-200">
          <Link to="/dashboard" className="block px-3 py-2 rounded-lg text-sm text-slate-600 hover:bg-slate-100">
            Back to app
          </Link>
        </div>
      </aside>
      <main className="flex-1 overflow-auto p-6">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
